<main [ngClass]="{ loading: isloading }">
  <router-outlet></router-outlet>
</main>
